export const CONSTANTS = {
  ID: 'id',
  USER_ID: 'userId',
  TYPE: 'type',
  DATA: 'data',
  READ: 'read',
  SENT_MAIL: 'sent_mail',
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
}

export const TYPE = {
  AVAILABILITY: 'availability',
  AVAILABILITY_LOW: 'availability.low',
  AVAILABILITY_AGAIN: 'availability.again',
  BLOCKINGREASONS: 'blockingreason',
  BLOCKINGREASONS_NEW: 'blockingreason.new',
  BACKORDERS: 'backorder',
  BACKORDER_SHIFT: 'backorder.shift',
  SYSTEM: 'system',
  SYSTEM_LOGOUT: 'system.logout',
  SYSTEM_SUPPORTACCESSLOGOUT: 'system.supportaccesslogout',
  SYSTEM_SUPPORTACCESSKICK: 'system.supportaccesskick',
}

export const TYPE_GROUP = {
  AVAILABILITY: [TYPE.AVAILABILITY_LOW, TYPE.AVAILABILITY_AGAIN],
  SYSTEM: [TYPE.SYSTEM_SUPPORTACCESSLOGOUT, TYPE.SYSTEM_LOGOUT],
  BLOCKINGREASON: [TYPE.BLOCKINGREASONS],
  BACKORDER: [TYPE.BACKORDERS],
}

export const TYPE_INFO = {
  [TYPE.AVAILABILITY]: { notificationType: 'info' },
  [TYPE.AVAILABILITY_LOW]: { notificationType: 'info' },
  [TYPE.AVAILABILITY_AGAIN]: { notificationType: 'info' },
  [TYPE.SYSTEM_LOGOUT]: { notificationType: 'warning', timeout: 30000 },
  [TYPE.SYSTEM_SUPPORTACCESSLOGOUT]: { notificationType: 'warning', timeout: 30000 },
  [TYPE.BLOCKINGREASONS_NEW]: { notificationType: 'warning' },
  [TYPE.BACKORDER_SHIFT]: { notificationType: 'warning' },
}
